(function () {
  document.querySelectorAll('[data-faq-custom]').forEach(function (root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.faq-custom__item'));
    items.forEach(function (item) {
      var toggle = item.querySelector('[data-faq-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');
        items.forEach(function (i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });
  });
})();
